// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wheeldiv[data-v-56fc2336]{display:grid;grid-template-columns:1fr 4fr 1fr;grid-template-rows:1fr 1fr 1fr;text-align:center;margin:5px}.checkbox[data-v-56fc2336]{height:13px;width:13px}p[data-v-56fc2336]{margin:0}", ""]);
// Exports
module.exports = exports;
